module.exports = __webpack_public_path__ + "static/media/burger.ad374071.svg";